import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export default function initBoxCarousel() {
  const carouselSections = document.querySelectorAll(".box-carousel-section");

  if (!carouselSections.length) return;

  carouselSections.forEach((carouselSection) => {
    const swiperContainer = carouselSection.querySelector(".swiper");
    const progressBar = carouselSection.querySelector(".carousel-progress-bar");
    const nextButton = carouselSection.querySelector(".carousel-button-next");
    const prevButton = carouselSection.querySelector(".carousel-button-prev");
    const carouselControls =
      carouselSection.querySelector(".carousel-controls");

    if (!swiperContainer || !progressBar) return;

    function updateProgressBar(swiperInstance) {
      const progress =
        ((swiperInstance.realIndex + 1) / swiperInstance.slides.length) * 100;
      progressBar.style.width = `${progress}%`;
    }

    function updateControlsVisibility(swiperInstance) {
      if (!carouselControls) return;
      if (swiperInstance.slides.length <= 1) {
        carouselControls.style.display = "none";
      } else {
        carouselControls.style.display = "";
      }
    }

    new Swiper(swiperContainer, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 24,
      loop: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      on: {
        init: function () {
          updateProgressBar(this);
          updateControlsVisibility(this);
        },
        slideChange: function () {
          updateProgressBar(this);
        },
      },
    });
  });
}
